import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useConfig } from '../../ConfigContextCore';
import emblemDark from '../../assets/emblem-dark.png';
import emblemLight from '../../assets/emblem-light.png';
import swachBharat from '../../assets/images/swach-bharat.png';
import vsezLogo from '../../assets/images/VSEZ_LOGO.png';
// import myGovIndia from '../../assets/images/myGovIndia.png';
// import DigitalIndia from '../../assets/images/DigitalIndia.png';
// import indiaPortal from '../../assets/images/india-portal.png';
import azadiKaAmritMahotsav from '../../assets/images/azadi-ka-amrit-mahotsav.png';
import g20Summit from '../../assets/images/g20Summit.png';
// import emblem from '../../assets/images/Emblem.png';
import emblem from '../../assets/images/Emblem_of_India.svg';
import swalUtils from '../../utils/swal';
import { getStaticNav } from '../../navData';
const Header = () => {
  const {
    changeFontSize,
    language,
    setLanguage,
    theme,
    setTheme,
    dynamicNav
  } = useConfig();

  const isDarkTheme = theme === 'dark';
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = React.useState('');

  const toggleTheme = (newTheme) => {
    setTheme(newTheme);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;

    // Flatten navItems for searching
    const searchableItems = [];
    navItems.forEach(item => {
      searchableItems.push({ title: item.title, path: item.path });
      if (item.dropdown) {
        item.dropdown.forEach(subItem => {
          searchableItems.push({ title: subItem.title, path: subItem.path });
        });
      }
    });

    // Find a match
    const queryLower = searchQuery.toLowerCase();
    const match = searchableItems.find(item =>
      item.title && item.title.toLowerCase().includes(queryLower) && item.path !== '#' && item.path !== '/'
    );

    if (match) {
      navigate(match.path);
      setSearchQuery('');
    } else {
      // If no match in menu, maybe search for keywords
      const keywordsMap = {
        'rti': '/reports',
        'contact': '/contact',
        'map': '/location-map',
        'faq': '/faqs',
        'download': '/downloads',
        'circular': '/circulars',
        'notification': '/notifications',
        'unit': '/vsez-units',
        'sez': '/sez-scheme',
        'eou': '/eou-scheme',
        'infra': '/infrastructure',
        'about': '/about-vsez',
        'vizag': '/about-vizag',
        'tender': '/tenders-notice',
        'nodal': '/nodal-officers',
        'land': '/source-of-land',
        'gallery': '/photo-gallery',
        'press': '/press-releases'
      };

      const keywordMatch = Object.keys(keywordsMap).find(k => queryLower.includes(k));
      if (keywordMatch) {
        navigate(keywordsMap[keywordMatch]);
        setSearchQuery('');
      } else {
        swalUtils.error('No results found for "' + searchQuery + '"');
      }
    }
  };

  const translations = {
    English: {
      home: 'HOME',
      about: 'ABOUT',
      sez: 'SEZ',
      eou: 'EOU',
      admin: 'ADMINISTRATION',
      rti: 'RTI',
      info: 'INFO HUB',
      news: 'NEWS',
      tenders: 'TENDERS',
      brandTitle: 'Visakhapatnam Special Economic Zone',
      brandSubtitle: '(Govt. of India, Ministry of Commerce and Industry)',
      brandTagline: '"You do business... We take care of the rest..."',
      // commerce: 'WOO-COMMERCE'
    },
    Hindi: {
      home: 'मुख्य पृष्ठ',
      about: 'हमारे बारे में',
      sez: 'एसईजेड',
      eou: 'ईओयू',
      admin: 'प्रशासन',
      rti: 'आरटीआई',
      info: 'सूचना केंद्र',
      news: 'समाचार',
      tenders: 'निविदा',
      brandTitle: 'विशाखापत्तनम विशेष आर्थिक क्षेत्र',
      brandSubtitle: '(भारत सरकार, वाणिज्य और उद्योग मंत्रालय)',
      brandTagline: '"आप व्यवसाय करें... बाकी हम संभाल लेंगे..."',
      // commerce: 'ई-कॉमर्स'
    }
  };

  const t = translations[language] || translations.English;

  const navItems = (dynamicNav && Array.isArray(dynamicNav) && dynamicNav.length > 0) ? dynamicNav : getStaticNav(t);

  return (
    <header className={`site-header ${isDarkTheme ? 'dark-mode' : ''}`}>
      <div className="top-bar">
        <div className="container flex justify-between align-center">
          <div className="top-bar-left flex align-center">
            <Link to="/sitemap">{language === 'Hindi' ? 'साइटमैप' : 'Sitemap'}</Link>
            <span className="separator">|</span>
            <a href="#main-content">{language === 'Hindi' ? 'मुख्य सामग्री पर जाएँ' : 'Skip to Main Content'}</a>
            <span className="separator">|</span>
            <Link to="/screen-reader-access">{language === 'Hindi' ? 'स्क्रीन रीडर एक्सेस' : 'Screen Reader Access'}</Link>
            <span className="text-resize-group">
              <button className="text-resize-btn" onClick={() => changeFontSize('decrease')}>-A</button>
              <button className="text-resize-btn" onClick={() => changeFontSize('reset')}>A</button>
              <button className="text-resize-btn" onClick={() => changeFontSize('increase')}>+A</button>
            </span>
            <span className="separator">|</span>
            <select className="lang-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
              <option value="English">English</option>
              <option value="Hindi">हिन्दी</option>
            </select>
            <span className="theme-circles">
              <button
                className={`theme-circle theme-dark ${theme === 'dark' ? 'active' : ''}`}
                onClick={() => toggleTheme('dark')}
                title="Dark Theme"
              ></button>
              <button
                className={`theme-circle theme-light ${theme === 'light' ? 'active' : ''}`}
                onClick={() => toggleTheme('light')}
                title="Light Theme"
              ></button>
            </span>

            <Link style={{ marginLeft: '15px' }} to="/admin" className="admin-link">{language === 'Hindi' ? 'अड्मिन' : 'Admin'}</Link>
          </div>
          <div className="top-bar-right flex align-center">
            <form onSubmit={handleSearch} className="search-wrapper-premium">
              <i className="fa fa-search search-icon"></i>
              <input className="form-control-premium shadow-sm bg-color"
                placeholder={language === 'Hindi' ? 'खोजें...' : "Search..."} type="text" value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} />
            </form>
          </div>
        </div>
      </div>

      <div className="main-header">
        <div className="container flex justify-between align-center">
          <div className="logo-section">
            <div className="national-emblem">
              <img
                src={emblem}
                alt="Government of India Emblem"
                className="emblem-img"
              />
            </div>
            <Link to="/" className="brand-text">
              <div className="text-primary main-title">{t.brandTitle}</div>
              <div className="text-secondary subtitle">{t.brandSubtitle}</div>
              <div className="tagline">{t.brandTagline}</div>
            </Link>
          </div>
          <div className="campaign-logo">
            <img src={vsezLogo} alt="VSEZ Logo" className="vsez-logo-header" />
            <img src={azadiKaAmritMahotsav} alt="Azadi Ka Amrit Mahotsav" className="vsez-logo-header" />
            <img src={g20Summit} alt="G20 Summit" className="vsez-logo-header" />
            <img src={swachBharat} alt="Swachh Bharat" className="swach-bharat-logo" />
          </div>
        </div>
      </div>

      <nav className="main-nav">
        <div className="container">
          <ul className="flex nav-list">
            {navItems.map((item, idx) => {
              const subItems = item.children || item.dropdown || [];
              const hasDropdown = subItems.length > 0;
              return (
                <li key={idx} className={hasDropdown ? 'has-dropdown' : ''}>
                  <Link to={item.path}>{language === 'Hindi' ? (item.title_hi || item.title) : item.title}</Link>
                  {hasDropdown && (
                    <div className="dropdown">
                      <ul>
                        {subItems.map((sub, sIdx) => (
                          <li key={sIdx}>
                            <Link to={sub.path}>{language === 'Hindi' ? (sub.title_hi || sub.title) : sub.title}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
      <div className="announcement-banner">
        <div className="announcement-badge">
          <span className="announcement-icon-wrapper">
            <i className="fa fa-bullhorn text-pulse"></i>
          </span>
          <span className="announcement-badge-text">
            {language === 'Hindi' ? 'जन-सुनवाई' : 'JAN-SUNWAI'}
          </span>
        </div>
        <div className="announcement-viewport">
          <div className="announcement-track">
            <span className="announcement-text">
              {language === 'Hindi'
                ? 'हितधारकों की शिकायतों के निवारण के लिए प्रत्येक मंगलवार और गुरुवार को जन-सुनवाई वर्चुअल बैठक आयोजित की जाएगी।'
                : 'Jan-Sunwai virtual meeting will be held on every TUESDAY and THURSDAY for Redressal of Grievances of Stakeholders.'}
            </span>
            <span className="announcement-separator">✦</span>
            <span className="announcement-text">
              {language === 'Hindi'
                ? 'हितधारकों की शिकायतों के निवारण के लिए प्रत्येक मंगलवार और गुरुवार को जन-सुनवाई वर्चुअल बैठक आयोजित की जाएगी।'
                : 'Jan-Sunwai virtual meeting will be held on every TUESDAY and THURSDAY for Redressal of Grievances of Stakeholders.'}
            </span>
            <span className="announcement-separator">✦</span>
          </div>
        </div>
      </div>
    </header >
  );
};

export default Header;
